import {defineComponent, reactive, computed, PropType} from '@vue/composition-api';
import {allPromotionsWithNone, packageIds, PromotionType} from '@/states/promotion-state';
import {Company} from "@/views/admin-companies/admin-companies-types";
import {updateCompanyIncludedPackages} from "@/functions/promotion-functions";

export default defineComponent({
    props: {
        company: {
            type: Object as PropType<Company>,
            required: true
        },
    },
    emits: ["submit"],
    setup(props, context) {
        const state = reactive({
            loading: false,
            packages: allPromotionsWithNone.map(p => ({
                type: p,
                isActive: props.company.includedPackages.includes(p),
            })) as {
                type: PromotionType;
                isActive: boolean;
            }[],
            volumePackageIsLight: props.company.volumePackageIsLight,
        });

        const isSubmitEnabled = computed(
            () => state.packages.some(
                p => p.isActive && !props.company.includedPackages.includes(p.type) || !p.isActive && props.company.includedPackages.includes(p.type)
            ) || state.volumePackageIsLight !== props.company.volumePackageIsLight
        );
        const packages = computed<{ type: PromotionType }[]>(() => allPromotionsWithNone.map(p => ({type: p})));
        
        const isVolumePackageSelected = computed(() => {
            const volumePackage = state.packages.find(p => p.type === 'volume');
            return volumePackage?.isActive || false;
        });

        const onSubmit = async () => {

            state.loading = true;

            const includedPackages = state.packages.filter(p => p.isActive).map(p => p.type);
            const includedPackageIds = state.packages.filter(p => p.isActive).map(p => packageIds[p.type]);

            await updateCompanyIncludedPackages(props.company.id, includedPackageIds, state.volumePackageIsLight);

            // Ensure that the company object reflects the light volume package status.
            // Instead of re-fetching the entire company, we just update the property here.
            props.company.volumePackageIsLight = state.volumePackageIsLight;

            context.emit("submit", includedPackages);

            state.loading = false;

        }

        return {
            state,
            onSubmit,
            packages,
            isSubmitEnabled,
            isVolumePackageSelected
        };
    }
});